import { render, staticRenderFns } from "./formulario-demo.vue?vue&type=template&id=8b6a4176&"
import script from "./formulario-demo.component.ts?vue&type=script&lang=ts&"
export * from "./formulario-demo.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports